import { useHistory } from 'react-router-dom';

import LoaderButton from '../../components/buttons/loaderButton'

const HomepagePublicLoginButton = () => {
  const history = useHistory();
  return <div><LoaderButton onClick={() => { history.push("/sign-in") }} text="Login" /></div>
}

export default HomepagePublicLoginButton